import { emphasize } from '@material-ui/core/styles/colorManipulator';

const secondaryStyle = theme => ({
  root: {
    backgroundColor: 'rgba(0, 0, 0, 0.09)',
    flexGrow: 1,
    width: '100%',
    fontSize: 14,
    fontFamily: `"LLCircularWeb-Book", "Helvetica Neue", Helvetica, Arial, sans-serif`,
    border: '1px solid transparent',

    '& .Mui-error': {
      border: '1px solid red',
    },

    '&:hover:enabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.13)',
      border: '1px solid #CACDD2',
    },
  },
  input: {
    display: 'flex',
    padding: 0,
    paddingLeft: '10px',

    '& span': {
      width: '0px',
    },

    '& svg': {
      color: 'black',
    },
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  chip: {
    margin: `${theme.spacing(1 / 2)}px ${theme.spacing(1 / 4)}px`,
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 14,
    width: '95%',
    padding: '0',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  placeholder: {
    position: 'absolute',
    left: '11px',
    fontSize: 14,
  },
  paper: {
    position: 'absolute',
    marginTop: '1px',
    zIndex: 1,
    left: 0,
    right: 0,
    width: 'fit-content',
    minWidth: '200px',
    borderRadius: '0px 0px 16px 16px',
    overflow: 'hidden',
  },
  divider: {
    height: theme.spacing(2),
  },
  menuItem: {
    fontSize: 14,
    fontFamily: `"LLCircularWeb-Book", "Helvetica Neue", Helvetica, Arial, sans-serif`,
    borderBottom: '1px solid #CACDD2',
  },
});

export default secondaryStyle;
